import React from 'react';
import HeroSection from '../componants/HeroSection';
import Services from '../componants/Services';
import About from '../componants/About';
import WhyChooseUs from '../componants/WhyChooseUs';
import Testimonials from '../componants/Testimonials';
import FAQ from '../componants/FAQ';
import Contact from '../componants/Contact';
import LoanInquiry from '../componants/LoanInquiry';
import Map from '../componants/Map';

export default function Home() {
  return (
    <>
      <HeroSection />
      <Services />
      <About />
      <WhyChooseUs />
      <Testimonials />
      <FAQ />
      <Contact />
      <LoanInquiry />
      <Map />
    </>
  );
}